import { createAction } from 'app/utils/redux'
import Client, { saveJWTToken } from 'mz-sdk/client'
import { LOGIN_ENDPOINT, PROVIDER_UID_ENDPOINT } from 'app/constants/endpoints'
import {
  LOGIN_USER,
  SET_AUTH_ERROR,
  SET_PROVIDER_INFO,
} from 'app/constants/actions'
import posthog from 'posthog-js'

export const login = createAction(LOGIN_USER)

export const setAuthError = createAction(SET_AUTH_ERROR)

export const setProviderInfo = createAction(SET_PROVIDER_INFO)

export const doLogin = (userData) => {
  return async (dispatch) => {
    try {
      const authResponse = await Client.post(LOGIN_ENDPOINT, { body: userData })
      if (saveJWTToken(authResponse)) {
        dispatch(setAuthError(null))
        const providerData = await dispatch(getProviderInfo())
        if (providerData) {
          posthog.identify(userData.email, {
            provider_id: providerData.id?.toString(),
            provider_email: userData.email,
            provider_name: providerData.name,
          })
        }
        return true
      }
      return dispatch(setAuthError('Unable to authenticate'))
    } catch (error) {
      // TODO: use error message from the backend when we will decide
      //       how to handle error messages in general
      posthog.capture('Provider Dashboard Sign-in Error', {
        provider_email: userData.email,
        error_code: error.response?.code,
        error_message: error.response?.message,
      })
      return dispatch(
        setAuthError('Unable to login with given email and password.')
      )
    }
  }
}

export const getProviderInfo = () => {
  return async (dispatch) => {
    try {
      const providerData = await Client.get(PROVIDER_UID_ENDPOINT)
      const { email } = decodeJwtToken()
      providerData.email = email
      dispatch(setProviderInfo(providerData))
      return providerData
    } catch (error) {
      posthog.capture('Provider Info Fetch Error', {
        error_code: error.response?.code,
        error_message: error.response?.message,
      })
      return null
    }
  }
}

function decodeJwtToken() {
  const token = localStorage.getItem('mozio-auth-token')
  if (token) {
    const base64Payload = token.split('.')[1]
    return JSON.parse(atob(base64Payload))
  }

  return undefined
}
